/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import 'es6-promise';

class HeaderContext {
  static initClass() {
    this.NOTIFICATIONS = '_c_notifications';
    this.MODAL = '_c_modal';
    this.SUBNAV = '_c_subnav';
    this.SEARCH = '_c_search';
    this.singletonNamespace = '_header_context_instance';
  }

  static _getInstance() {
    return window[this.singletonNamespace] || (window[this.singletonNamespace] = new HeaderContext());
  }

  constructor() {
    this.callbacks = [];
  }

  static register(callback) {
    return this._getInstance().callbacks.push(callback);
  }

  static switch(newContext) {
    const {
      callbacks
    } = this._getInstance();
    const promises = [];

    // invoke the callbacks and collect any promises returned
    for (var callback of Array.from(callbacks)) {
      var promise = callback(newContext);
      if (promise) {
        promises.push(promise);
      }
    }

    if (promises.length) {
      // return a promise that only resolves when all of the given promises resolve
      return Promise.all(promises);
    }
  }
}
HeaderContext.initClass();

export default HeaderContext;
